import React, { useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import { Typography, Grid } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { dynamicLayout } from 'constants.js';
import { SelectInput } from 'components';

const useStyles = makeStyles(theme => ({
  selectJustifiedContainer: {
    display: 'flex',
    minWidth: '14rem',
    alignItems: 'center',
    justifyContent: 'space-between',
    margin: theme.spacing(1)
  },
  selectContainer: {
    display: 'flex',
    minWidth: '14rem',
    alignItems: 'center',
    margin: theme.spacing(1)
  },
  outerLine: {
    stroke: '#546e7a',
    strokeWidth: '4'
  },
  innerLine: {
    stroke: '#546e7a',
    strokeWidth: '2'
  },
  label: {
    marginRight: '10px'
  },
  svg: {
    opacity: '0.8'
  }
}));
const Layout = props => {
  const classes = useStyles();
  let { thisTemplate, modifyRows, modifyColumns, isTemplateReadOnly } = props;

  const [rowValues, setRowValues] = useState(thisTemplate.rows || 1);
  const [columnValues, setColumnValues] = useState(thisTemplate.columns || 1);

  const handleRowChange = event => {
    setRowValues(event.target.value);
    modifyRows(event.target.value);
  };

  const handleColumnChange = event => {
    setColumnValues(event.target.value);
    modifyColumns(event.target.value);
  };

  let minWidth = 0;
  let minHeight = 0;
  let maxWidth = 30;
  let maxHeight = 40;

  let coordinates = [];

  let getRows = () => {
    let rows = rowValues;
    let horizontal = rows - 1;
    let individualHeight = maxHeight / rows;

    let height = individualHeight;

    for (let i = 0; i < horizontal; i++) {
      coordinates.push({ x1: minWidth, y1: height, x2: maxWidth, y2: height });
      height = height + individualHeight;
    }
  };

  let getColumns = () => {
    let columns = columnValues;
    let vertical = columns - 1;
    let individualWidth = maxWidth / columns;

    let width = individualWidth;

    for (let i = 0; i < vertical; i++) {
      coordinates.push({ x1: width, y1: minHeight, x2: width, y2: maxHeight });
      width = width + individualWidth;
    }
  };

  getRows();
  getColumns();

  const getRange = size =>
    Array(size)
      .fill()
      .map((v, i) => i + 1);
  let values = {
    rows: getRange(dynamicLayout.maxRows),
    columns: getRange(dynamicLayout.maxColumns)
  };

  const getOptions = options => {
    return {
      list: options,
      keyId: 'option',
      valueId: 'option',
      displayValueId: 'option'
    };
  };

  return (
    <>
      <Grid container style={{ padding: '8px 0px 0px 0px' }}>
        <Grid item className={classes.selectJustifiedContainer}>
          <Typography>{'Layout : '}</Typography>
          <SelectInput
            size="small"
            label="Rows"
            value={rowValues}
            disabled={isTemplateReadOnly}
            onChange={handleRowChange}
            options={getOptions(values.rows)}
          />
          <CloseIcon></CloseIcon>
          <SelectInput
            size="small"
            label="Columns"
            value={columnValues}
            disabled={isTemplateReadOnly}
            onChange={handleColumnChange}
            options={getOptions(values.columns)}
          />
        </Grid>
      </Grid>
      <Grid container>
        <Grid item className={classes.selectContainer}>
          <Typography className={classes.label}>{'Preview : '}</Typography>
          <svg width={maxWidth} height={maxHeight} className={classes.svg}>
            <line
              x1={minWidth}
              y1={minHeight}
              x2={minWidth}
              y2={maxHeight}
              className={classes.outerLine}
            />
            <line
              x1={maxWidth}
              y1={minHeight}
              x2={maxWidth}
              y2={maxHeight}
              className={classes.outerLine}
            />
            <line
              x1={minWidth}
              y1={minHeight}
              x2={maxWidth}
              y2={minHeight}
              className={classes.outerLine}
            />
            <line
              x1={minWidth}
              y1={maxHeight}
              x2={maxWidth}
              y2={maxHeight}
              className={classes.outerLine}
            />
            {coordinates.map((coordinate, index) => (
              <line
                x1={coordinate.x1}
                y1={coordinate.y1}
                x2={coordinate.x2}
                y2={coordinate.y2}
                key={index}
                className={classes.innerLine}></line>
            ))}
          </svg>
        </Grid>
      </Grid>
    </>
  );
};
export default Layout;
